<script setup lang="ts">
import { computed, ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head'
import { useLanguageSwitcher } from '@hantecmarket/widget-core'
import type { SupportedLocale } from '@/types/types'

const route = useRoute()
const languageSwitcher = useLanguageSwitcher()
const origin = ref('')

onMounted(() => {
  origin.value = window.location.origin
})

const currentLocale = computed((): SupportedLocale => {
  return languageSwitcher.getLocale() as SupportedLocale
})

const canonicalUrl = computed(() => {
  const currentPath = route.path
  return currentPath.endsWith('/') ? `${origin.value}${currentPath}` : `${origin.value}${currentPath}/`
})

useHead({
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl
    }
  ]
})
</script>